namespace Gamification.Gamification {
    export namespace ProdottiClassiAssetEsperienzeService {
        export const baseUrl = 'Gamification/ProdottiClassiAssetEsperienze';

        export declare function Create(request: Serenity.SaveRequest<ProdottiClassiAssetEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiClassiAssetEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiClassiAssetEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiClassiAssetEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiClassiAssetEsperienze/Create",
            Update = "Gamification/ProdottiClassiAssetEsperienze/Update",
            Delete = "Gamification/ProdottiClassiAssetEsperienze/Delete",
            Retrieve = "Gamification/ProdottiClassiAssetEsperienze/Retrieve",
            List = "Gamification/ProdottiClassiAssetEsperienze/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiClassiAssetEsperienzeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
